import { useMemo, ReactNode } from 'react'
import { useTranslation } from 'react-i18next'
import { useLocation, useNavigate } from 'react-router-dom'

import { Header, Tabs } from '@/components'
import { ROUTES_ADMIN } from '@/router'
import { useAuth } from '@/providers'

import { isKaiManagement } from '@/helpers'

import { AgentsList } from './agents'
import {
  ConversationsAcquisition,
  ConversationsDevelopment,
} from './conversations'
import { Dashboard } from './dashboard'
import styles from './ai-center.module.css'
import { TagsList } from './tags'

export const AiCenter = () => {
  const { t } = useTranslation('screenAiCenter')

  const { whoAmI } = useAuth()

  const isKaiManagementUser = isKaiManagement(whoAmI?.email)

  const location = useLocation()
  const page = location.pathname.split('/').pop()

  const navigate = useNavigate()

  const object: Record<string, ReactNode> = {
    agent: <AgentsList />,
    'conversation-acquisition': <ConversationsAcquisition />,
    conversation: <ConversationsAcquisition />,
    'conversation-development': <ConversationsDevelopment />,
    dashboard: <Dashboard />,
    tags: <TagsList />,
  }

  const tabs = useMemo(() => {
    if (isKaiManagementUser) {
      return [
        {
          title: t('buttonAgentTabs'),
          isActive: page === 'agent',
          onSelect: () => navigate(ROUTES_ADMIN.AI_CENTER.AGENT.fullPath()),
        },
        {
          title: t('buttonConversationAcquisitionTabs'),
          isActive:
            page === 'conversation-acquisition' || page === 'conversation',
          onSelect: () =>
            navigate(
              ROUTES_ADMIN.AI_CENTER.CONVERSATION_ACQUISITION.fullPath(),
            ),
        },
        {
          title: t('buttonConversationDevelopmentTabs'),
          isActive: page === 'conversation-development',
          onSelect: () =>
            navigate(
              ROUTES_ADMIN.AI_CENTER.CONVERSATION_DEVELOPMENT.fullPath(),
            ),
        },
        {
          title: t('buttonDashboardTabs'),
          isActive: page === 'dashboard',
          onSelect: () => navigate(ROUTES_ADMIN.AI_CENTER.DASHBOARD.fullPath()),
        },
        {
          title: t('buttonTagsTabs'),
          isActive: page === 'tags',
          onSelect: () => navigate(ROUTES_ADMIN.AI_CENTER.TAGS.fullPath()),
        },
      ]
    }

    return [
      {
        title: t('buttonConversationTabs'),
        isActive:
          page === 'conversation-acquisition' || page === 'conversation',
        onSelect: () =>
          navigate(ROUTES_ADMIN.AI_CENTER.CONVERSATION_ACQUISITION.fullPath()),
      },
    ]
  }, [location.pathname, isKaiManagementUser])

  return (
    <div>
      <Header title={t('title')} description={t('description')} />

      <div className={styles.content}>
        <Tabs items={tabs} />

        {object?.[page as keyof typeof object]}
      </div>
    </div>
  )
}
